import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CallWaiterService, UserActivityClickTrackingDirective } from '@core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TextComponent } from '@app/components/text/text.component';
import { TextTranslatePipe } from '@app/pipes/text-translate.pipe';
import { ImageTranslatePipe } from '@app/pipes/image-translate.pipe';
import { style, transition, trigger, useAnimation } from '@angular/animations';
import { fadeIn } from 'ng-animate';
import { CallWaiterButtonsSchema } from '@app/views/call-waiter-buttons/call-waiter-buttons.schema';
import { ImageComponent } from '@app/components/image/image.component';
import { LanguageService } from '@app/services';

@Component({
  selector: 'app-call-waiter-buttons',
  templateUrl: './call-waiter-buttons.component.html',
  styleUrl: './call-waiter-buttons.component.scss',
  imports: [
    UserActivityClickTrackingDirective,
    TextComponent,
    TextTranslatePipe,
    ImageTranslatePipe,
    ImageComponent,
  ],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        useAnimation(fadeIn, {
          params: { timing: 0.4 },
        }),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallWaiterButtonsComponent {

  private readonly languageService = inject(LanguageService);
  protected readonly callWaiterService = inject(CallWaiterService);

  public readonly config = input.required<CallWaiterButtonsSchema>();

  protected readonly currentLanguage = toSignal(this.languageService.currentLanguage$, {
    requireSync: true,
  });

  protected readonly withCallWaiterMain = toSignal(this.callWaiterService.withMain$, {
    initialValue: false,
  });

  protected readonly withCallWaiterAnotherRound = toSignal(this.callWaiterService.withTertiary$, {
    initialValue: false,
  });

  protected readonly withCallWaiterRequestBill = toSignal(this.callWaiterService.withSecondary$, {
    initialValue: false,
  });

  protected readonly callWaiterMain = toSignal(this.callWaiterService.mainStatus$, {
    initialValue: true,
  });

  protected readonly callWaiterAnotherRound = toSignal(this.callWaiterService.tertiaryStatus$, {
    initialValue: true,
  });

  protected readonly callWaiterRequestBill = toSignal(this.callWaiterService.secondaryStatus$, {
    initialValue: true,
  });

  protected readonly active = computed(() => {
    return this.callWaiterMain() || this.callWaiterAnotherRound() || this.callWaiterRequestBill();
  });

  protected onClickCallWaiterMain($event: MouseEvent) {
    $event.preventDefault();
    this.callWaiterService.setMain(!this.callWaiterMain());
  }

  protected onClickCallWaiterAnotherRound($event: MouseEvent) {
    $event.preventDefault();
    this.callWaiterService.setTertiary(!this.callWaiterAnotherRound());
  }

  protected onClickCallWaiterRequestBill($event: MouseEvent) {
    $event.preventDefault();
    this.callWaiterService.setSecondary(!this.callWaiterRequestBill());
  }

}
